<template>
  <div class="xunLRecordPage">
    <div class="TabsList">
      <van-list
        v-model="recordLoading"
        :finished="finished"
        finished-text="没有更多了"
         @load="loadBaselist"
      >
        <div
          v-for="(item, index) in baselist"
          :key="index"
          class="itemList clear"
          @click="getJumpDetail(item)"
        >
          <p>
            {{ item.userName }}
            <van-tag type="warning">{{ item.postName }}</van-tag>
          </p>
          <p class="orgName">{{ item.org }}</p>
          <p class="protectForestTime">{{ item.protectForestTime }}</p>
          <span class="xunLType">{{ item.typeName }}</span>
          <!-- <span class="jumpBtn" >查看</span> -->
        </div>
      </van-list>
      <div class="emptypage" v-if="noneRankListType">
        <van-image :src="baseUrl + 'empty.png'" />
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "xunLRecord",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      baselist: [],
      sourceList: [],
      recordLoading: true,
      finished: false,
      sourcePageNum: 0,
      pageSize: 30,
      sourceTotal: "",
      noneRankListType: false,
      clientType: getDeviceType(),
    };
  },
  mounted() {
    this.getRecordList();
  },
  methods: {
    getRecordList() {
      let _this = this;
      if (
        _this.sourcePageNum != 0 &&
        _this.sourcePageNum * _this.pageSize >= parseInt(_this.sourceTotal)
      ) {
        return;
      }
      _this.sourcePageNum += 1;
      _this.$api.xunLData
        .xunLRecordList(_this.sourcePageNum, _this.pageSize)
        .then((res) => {
          if (res.code == "1" && res.data.list[0]) {
            _this.sourceTotal = parseInt(res.data.total);
            _this.sourceList = res.data.list;
            _this.viewLists();
            // 加载状态结束
            this.recordLoading = false;
            if (_this.sourcePageNum * _this.pageSize >= _this.sourceTotal) {
              _this.finished = true;
            } 
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
    viewLists() {
      let _this = this;
      _this.baselist = _this.baselist.concat(this.sourceList);
    },
    getJumpDetail(item) {
      let Url = window.location.protocol + "//" + window.location.host + "";
      let timestamp = Date.parse(new Date());
      let token = this.$route.query.token;
      Url =
        Url +
        "/dhome-lzz-lzt-h5/#/xunLDetail?token=" +
        token +
        "&commonId=" +
        item.id +
        "&commonType=" +
        item.type +
        "&uid=" +
        item.uid +
        "&timestamp=" +
        timestamp;
      if (this.clientType == "android") {
        //android
        window.android.getInfo(105, Url);
      } else {
        //IOS
        window.webkit.messageHandlers.getJumpUrl.postMessage(Url);
      }
    },
    loadBaselist(){
        this.getRecordList();
    },
  },
};
</script>
<style lang="less">
.xunLRecordPage {
  width: 100%;
  max-height: 600px;
  overflow-y: scroll;
  font-family: "PingFangSC-Regular", "PingFang SC";
  .TabsList {
    width: 100%;
    padding: 0 16px;
    padding-bottom: 30px;
    .itemList {
      background: #ffffff;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.11);
      border-radius: 6px;
      padding: 14px 12px;
      margin: 12px 0;
      position: relative;
      p {
        margin: 6px 0;
        font-size: 14px;
        color: #000;
        line-height: 20px;
        opacity: 0.4;
      }
      p:first-child {
        font-size: 16px;

        color: #333;
        line-height: 24px;
        opacity: 1;
        .van-tag.van-tag--warning {
          background-color: #fff6e6;
          color: #ffa70a;
          font-size: 10px;
          padding: 2px 2px;
        }
      }
      p.protectForestTime{
        font-size: 12px;
      }
      .xunLType {
        position: absolute;
        right: 24px;
        top: 32px;
        font-size: 16px;
        font-weight: 400;
        color: #5d5c5c;
        line-height: 22px;
      }
      .jumpBtn {
        display: inline-block;
        position: absolute;
        right: 19px;
        bottom: 20px;
        font-size: 12px;
        padding: 3px 9px;
        background-color: #f0faf7;
        border-radius: 9px;
        border: 1px solid #35c375;
        color: #35c375;
      }
    }
  }
}
</style>